export enum WistiaVideoId {
  DASHBOARD_ANNOUNCEMENT_TEXT = '3o13a5zh9p',
  PRO_FEATURES = 'g3n7zvfdfa',
  PREMIUM_FEATURES = 'xpuuqea34o',
  ONBOARDING_SUCCESS = 'b9wjyus86q'
}